module.exports = __webpack_public_path__ + "img/partner_fanuc.48e64c78.jpeg";